<template>
    <!-- fullscreen
    v-model="dialogState"
    max-width="1200px"
    hide-overlay
    transition="dialog-bottom-transition" -->
    <v-dialog
        v-model="dialogState"
        max-width="1200px"
    >
        <v-card elevation="0" class="ma-auto pt-7 pb-5 px-7">
            <h2 class="ml-3 font-weight-light primary--text">
                Nuevo Cliente
            </h2>
            <TtForm />
        </v-card>
    </v-dialog>
</template>
<script>
    import TtForm from './TtForm.vue'

    export default {
        name: 'TtFormDialog',
        components: {
            TtForm
        },
        computed: {
            dialogState: {
                get: function () {
                    return this.$store.state.teletrabajo.IsOpenTtFormDialog
                },
                set: function () {
                    this.$store.dispatch('teletrabajo/closeTtFormDialog')
                    if (this.$store.state.teletrabajo.TtFormType != "create")
                        this.$store.dispatch('teletrabajo/setDefaultTtForm')
                }
            },
        }
    }
</script>